module.exports = __webpack_public_path__ + "img/img_4.9f3bd682.jpg";